import { render, staticRenderFns } from "./CreateSearch.vue?vue&type=template&id=6c211c49&scoped=true&"
import script from "./CreateSearch.vue?vue&type=script&lang=js&"
export * from "./CreateSearch.vue?vue&type=script&lang=js&"
import style0 from "./CreateSearch.vue?vue&type=style&index=0&id=6c211c49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c211c49",
  null
  
)

export default component.exports